import _get from 'lodash.get';
import store from '@/store/index';
import Logger from '@/Logger';

const logger = new Logger('Strings', 'GetStrings');

// This helper is intended to ensure the app functions when a string path is undefined.
// It also provides clearer error handling and logs missing stings while in development.
export default function (path, en, nl) {
  // Allow custom strings
  if (!path && en && nl) return store.state.stringsStore.language === 'en' ? en : nl;

  let string = _get(store.getters.strings, path);

  if (typeof string !== 'string') {
    // Log the missing string in development ONLY
    if (!store.state.logStore.missingStrings.includes(path) && process.env.NODE_ENV === 'development') {
      logger.warn('getString', path, `is type ${typeof string}`);
      store.dispatch('missingString', path);
    }

    // if the string is not defined, return the last word in the path prefixed with *
    string = path ? `*${path.split('.').pop()}` : undefined;
  }

  return string;
}
